import React, { useMemo } from "react";
import KC_Input from "../../designsystem/KC_FormInput/KC_Input";
import KC_UIText from "../../designsystem/typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../../designsystem/ds_commons";
import { tt } from "../../utils/i18n/i18n";
import { getCountriesByLanguage } from "../../utils/i18n/getCountriesByLang";
import Address from "@tootsweet/model/entities/Address";
import KC_Heading4 from "../../designsystem/typography/KC-Heading/KC_Heading4";

interface Props {
  address?: Address;
  setFieldValue: (field: string, value: any) => void;
  fieldPrefix?: string;
  disabled?: boolean;
}

export default function ShippingAddressForm(props: Props) {
  const { ALL_COUNTRIES_NAME, ALL_COUNTRIES_CODE } = useMemo(() => {
    return getCountriesByLanguage();
  }, []);

  const fieldPrefix = props.fieldPrefix || "shippingAddress";

  return (
    <div className="d-flex flex-column st-gap">
      <div>
        <label htmlFor={`${fieldPrefix}.countryCode`}>
          <KC_UIText
            weight={KC_Weights.md}
            text={tt("shipping_address_country")}
          />
        </label>
        <div className="kc-input-wrapper">
          <select
            id={`${fieldPrefix}-countryCode`}
            className="kc_input pl-3"
            onChange={(e) => {
              props.setFieldValue(`${fieldPrefix}.countryCode`, e.target.value);
              const countryName =
                ALL_COUNTRIES_NAME[ALL_COUNTRIES_CODE.indexOf(e.target.value)];
              props.setFieldValue(`${fieldPrefix}.country`, countryName);
            }}
            required={true}
            disabled={props.disabled}
            value={props.address?.countryCode || ""}
          >
            <option value="">
              {tt("shipping_address_country_placeholder")}
            </option>
            {ALL_COUNTRIES_NAME.map((name, idx) => {
              const val = ALL_COUNTRIES_CODE[idx];
              return (
                <option key={`country-${idx}-${val}`} value={val}>
                  {name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      {props.address?.countryCode !== "FR" && (
        <>
          <KC_Heading4
            className="text-red"
            text={tt("cannot_order_posa_outside_of_france_title")}
          />
        </>
      )}
      {props.address?.countryCode === "FR" && (
        <>
          <div>
            <label htmlFor={`${fieldPrefix}.line1`}>
              <KC_UIText
                weight={KC_Weights.md}
                text={tt("shipping_address_street")}
              />
            </label>
            <KC_Input
              id={`${fieldPrefix}-line1`}
              htmlFor={`${fieldPrefix}.line1`}
              placeholder={tt("shipping_address_street_placeholder")}
              type="text"
              setFieldValue={props.setFieldValue}
              required={true}
              value={props.address?.line1 || ""}
              disabled={props.disabled}
            />
          </div>

          <div className="d-flex flex-column flex-md-row st-gap">
            <div className="flex-grow-1">
              <label htmlFor={`${fieldPrefix}.postalCode`}>
                <KC_UIText
                  weight={KC_Weights.md}
                  text={tt("shipping_address_postal_code")}
                />
              </label>
              <KC_Input
                id={`${fieldPrefix}-postalCode`}
                htmlFor={`${fieldPrefix}.postalCode`}
                placeholder={tt("shipping_address_postal_code_placeholder")}
                type="text"
                setFieldValue={props.setFieldValue}
                required={true}
                value={props.address?.postalCode || ""}
                disabled={props.disabled}
              />
            </div>

            <div className="flex-grow-1">
              <label htmlFor={`${fieldPrefix}.city`}>
                <KC_UIText
                  weight={KC_Weights.md}
                  text={tt("shipping_address_city")}
                />
              </label>
              <KC_Input
                id={`${fieldPrefix}-city`}
                htmlFor={`${fieldPrefix}.city`}
                placeholder={tt("shipping_address_city_placeholder")}
                type="text"
                setFieldValue={props.setFieldValue}
                required={true}
                value={props.address?.city || ""}
                disabled={props.disabled}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
